module.exports = __webpack_public_path__ + "material-design.e833b2e2471274c238c0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/material-design/material-design.eot
// module id = 690
// module chunks = 3